export function computeRemainingQty(ordered: number, delivered: number): number {
    const safeOrdered = Number.isFinite(ordered) ? ordered : 0;
    const safeDelivered = Number.isFinite(delivered) ? delivered : 0;
    return Math.max(0, safeOrdered - safeDelivered);
}

export function clampShipQty(requested: number, remaining: number): number {
    const safeRequested = Number.isFinite(requested) ? requested : 0;
    const safeRemaining = Number.isFinite(remaining) ? remaining : 0;
    return Math.max(0, Math.min(safeRequested, safeRemaining));
}
